export default __webpack_public_path__ + "static/media/note-dark.a5c4f2df.png";